var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCup2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8.03125L8 12.0313",
    stroke: "#A2A2B8",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9987 12.0312C6.88293 12.0312 5.91184 12.7059 5.41047 13.7012C5.17101 14.1766 5.51462 14.6979 5.97121 14.6979L10.0262 14.6979C10.4828 14.6979 10.8264 14.1766 10.5869 13.7012C10.0856 12.7059 9.11446 12.0312 7.9987 12.0312Z",
    stroke: "#A2A2B8",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33203 3.36719H2.65517C1.99749 3.36719 1.66865 3.36719 1.46548 3.61421C1.2623 3.86123 1.32189 4.13784 1.44105 4.69105C1.66866 5.74776 2.16235 6.67612 2.8313 7.36719",
    stroke: "#A2A2B8",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6641 3.36719H13.3409C13.9986 3.36719 14.3274 3.36719 14.5306 3.61421C14.7338 3.86123 14.6742 4.13784 14.555 4.69105C14.3274 5.74776 13.8337 6.67612 13.1648 7.36719",
    stroke: "#A2A2B8",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9987 8.03385C10.576 8.03385 12.6654 5.95592 12.6654 3.39266C12.6654 3.32545 12.6639 3.25857 12.6611 3.19205C12.6326 2.52589 12.6184 2.19282 12.1669 1.78C11.7154 1.36719 11.2152 1.36719 10.2147 1.36719L5.78267 1.36719C4.78221 1.36719 4.28198 1.36719 3.83051 1.78C3.37904 2.19282 3.3648 2.52589 3.33631 3.19205C3.33347 3.25857 3.33203 3.32545 3.33203 3.39266C3.33203 5.95592 5.42137 8.03385 7.9987 8.03385Z",
    stroke: "#A2A2B8",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup2);
export default __webpack_public_path__ + "static/media/cup-2.7c0f884a227798387d44f79647d028c1.svg";
export { ForwardRef as ReactComponent };